import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/advisor');

const AdvisorFxs = {
    getClientsFx: domain.effect(api.advisor.getClients),
    removeClientFx: domain.effect(api.advisor.removeClient),
    getAdvisorInviteCodesFx: domain.effect(api.advisor.getAdvisorInviteCodes),
    getAdvisorByCodeFx: domain.effect(api.advisor.getAdvisorByCode),
    linkAdvisorFx: domain.effect(api.advisor.linkAdvisor),
    createZendeskTicketFx: domain.effect(api.advisor.createZendeskTicket),
    getAllGroupsFx: domain.effect(api.advisor.getAllGroups),
    getGroupFx: domain.effect(api.advisor.getGroup),
    createGroupFx: domain.effect(api.advisor.createGroup),
    removeAdvisorFromGroupFx: domain.effect(api.advisor.removeAdvisorFromGroup),
    moveAdvisorToGroupFx: domain.effect(api.advisor.moveAdvisorToGroup),
    moveGroupToNewParentGroupFx: domain.effect(api.advisor.moveGroupToNewParentGroup),
    editGroupFx: domain.effect(api.advisor.editGroup),
    removeGroupFx: domain.effect(api.advisor.removeGroup),
    unlinkClientFromAdvisorFx: domain.effect(api.advisor.unlinkClientFromAdvisor),
    linkClientToAdvisorFx: domain.effect(api.advisor.linkClientToAdvisor),
    changeAdvisorFx: domain.effect(api.advisor.changeAdvisor),
    linkAdvisorToGroupFx: domain.effect(api.advisor.linkAdvisorToGroup),
    sendInviteFx: domain.effect(api.advisor.sendInvite),
    getGroupByCodeFx: domain.effect(api.advisor.getGroupByCode),
    handoverClientFx: domain.effect(api.advisor.handoverClient),
    searchFx: domain.effect(api.advisor.search),
    setAdvisorPricingOptionsFx: domain.effect(api.advisor.setAdvisorPricingOptions),
    setGroupPricingOptionsFx: domain.effect(api.advisor.setGroupPricingOptions),
    getAdvisorPricingOptionsFx: domain.effect(api.advisor.getAdvisorPricingOptions),
    getGroupPricingOptionsFx: domain.effect(api.advisor.getGroupPricingOptions),
    setAdvisorPropertiesFx: domain.effect(api.advisor.setAdvisorProperties),
};

export default AdvisorFxs;
